"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateMultiSigProposal = exports.prepareMultiSigProposalEvaluation = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
/**
 * @hidden
 */
function prepareMultiSigProposalEvaluation(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { call, tx: { multiSig }, query: { multiSig: { votes, proposals }, }, }, }, context, } = this;
        const { proposal: { id, multiSig: { address: multiSigAddress }, }, proposal, action, } = args;
        const rawMultiSigAddress = (0, conversion_1.stringToAccountId)(multiSigAddress, context);
        const rawProposalId = (0, conversion_1.bigNumberToU64)(id, context);
        const signingAccount = context.getSigningAccount();
        const rawSigner = (0, conversion_1.stringToAccountId)(signingAccount.address, context);
        const [payer, { signers: multiSigSigners }, { status, approvalAmount, rejectionAmount }, hasVoted,] = yield Promise.all([
            proposal.multiSig.getPayer(),
            proposal.multiSig.details(),
            proposal.details(),
            votes([rawMultiSigAddress, rawProposalId], rawSigner),
        ]);
        if (!multiSigSigners.some(multiSigSigner => (0, conversion_1.signerToSignerValue)(multiSigSigner).value === signingAccount.address)) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.UnmetPrerequisite,
                message: 'The signing Account is not a signer of the MultiSig',
            });
        }
        const totalVotes = approvalAmount.plus(rejectionAmount).toNumber();
        if ((0, conversion_1.boolToBoolean)(hasVoted) && totalVotes > 1) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.UnmetPrerequisite,
                message: 'The signing Account has already voted for this MultiSig Proposal',
            });
        }
        let errorCode = types_1.ErrorCode.UnmetPrerequisite;
        let message;
        switch (status) {
            case types_1.ProposalStatus.Invalid:
                errorCode = types_1.ErrorCode.DataUnavailable;
                message = 'The MultiSig Proposal does not exist';
                break;
            case types_1.ProposalStatus.Rejected:
                message = 'The MultiSig Proposal has already been rejected';
                break;
            case types_1.ProposalStatus.Successful:
            case types_1.ProposalStatus.Failed:
                message = 'The MultiSig Proposal has already been executed';
                break;
            case types_1.ProposalStatus.Expired:
                message = 'The MultiSig Proposal has expired';
                break;
        }
        if (message) {
            throw new internal_1.PolymeshError({
                code: errorCode,
                message,
            });
        }
        const paidForBy = payer !== null && payer !== void 0 ? payer : undefined;
        if (action === types_1.MultiSigProposalAction.Approve) {
            const rawProposal = yield proposals(rawMultiSigAddress, rawProposalId);
            if (!rawProposal || rawProposal.isNone) {
                throw new internal_1.PolymeshError({
                    code: types_1.ErrorCode.DataUnavailable,
                    message: 'The proposal data was not found on chain',
                    data: { multiSig: multiSigAddress, proposalId: proposal.id.toString() },
                });
            }
            const runtimeInfo = yield call.transactionPaymentCallApi.queryCallInfo(rawProposal.unwrap(), rawProposal.encodedLength);
            return {
                transaction: multiSig.approve,
                paidForBy,
                args: [rawMultiSigAddress, rawProposalId, runtimeInfo.weight],
                resolver: undefined,
            };
        }
        else {
            return {
                transaction: multiSig.reject,
                paidForBy,
                args: [rawMultiSigAddress, rawProposalId],
                resolver: undefined,
            };
        }
    });
}
exports.prepareMultiSigProposalEvaluation = prepareMultiSigProposalEvaluation;
/**
 * @hidden
 */
const evaluateMultiSigProposal = () => new internal_1.Procedure(prepareMultiSigProposalEvaluation, {
    signerPermissions: true,
});
exports.evaluateMultiSigProposal = evaluateMultiSigProposal;
//# sourceMappingURL=evaluateMultiSigProposal.js.map